import React from "react"
import { Select, Input } from "semantic-ui-react"

const options = [{ key: 0, value: "PKCS12", text: "PKCS12" }]

export default class NCALayerComponent extends React.Component {
  state = {}
  render() {
    return (
      <>
        <div>
          <div>
            <h1 style={{ textAlign: "center" }}>
              Примеры использования методов NCALayer
            </h1>
            Выберите необходимый тип носителя
            <Input
              value="Добавить доступные токены"
              // onclick={getActiveTokensCall()}
              type="button"
            />
            <p></p>
            <Select
              options={options}
              value={options[0].value}
              id={"storageSelect"}
              fluid
            />
            <h2>1. Данные ключа</h2>
            <Input
              value="Получить данные ключа"
              // onclick="getKeyInfoCall();"
              type="button"
            />
            <div>
              <label>Алиас ключа</label>
              <div>
                <Input type="text" value="Alias" id="alias" disabled />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
